export enum SectionFormFieldEnum {
    TITLE = 'title',
    BODY = 'body'
}